import emojiMapping from "@revolt/ui/emojiMapping.json";
import { EMOJI_MAP_DEDUPE } from "@revolt/ui/emojis";
import type { IconName } from "@revolt/ui/icons/Icon";

// Section boundaries follow the semantic ordering of our existing bundled mapping.
// No third-party artwork or provider data is introduced.
export const EMOJI_SECTIONS: {
  id: string;
  label: string;
  icon: IconName;
  start: string;
}[] = [
  { id: "smileys", label: "Smileys & emotion", icon: "smiley", start: "smile" },
  {
    id: "people",
    label: "People & body",
    icon: "user",
    start: "speaking-head",
  },
  { id: "nature", label: "Nature & animals", icon: "leaf", start: "bouquet" },
  { id: "food", label: "Food & drink", icon: "cake", start: "strawberry" },
  { id: "travel", label: "Travel & places", icon: "globe", start: "stop-sign" },
  {
    id: "activities",
    label: "Activities",
    icon: "game-controller",
    start: "party-popper",
  },
  { id: "objects", label: "Objects", icon: "books", start: "camera" },
  { id: "symbols", label: "Symbols", icon: "heart", start: "red-circle" },
  { id: "flags", label: "Flags", icon: "flag", start: "regional-indicator-a" },
];
export const SECTIONED_EMOJI = (() => {
  const sections = EMOJI_SECTIONS.map((section) => ({
    ...section,
    emoji: [] as typeof EMOJI_MAP_DEDUPE,
  }));
  let previousBoundary = -1;
  const boundaries = EMOJI_SECTIONS.map((section) => {
    const boundary = emojiMapping.findIndex(
      (entry, index) =>
        index > previousBoundary && entry.slice(1).includes(section.start),
    );
    if (boundary >= 0) previousBoundary = boundary;
    return boundary;
  });
  const firstPosition = new Map<string, number>();
  emojiMapping.forEach((entry, index) => {
    if (!firstPosition.has(entry[0])) firstPosition.set(entry[0], index);
  });
  for (const emoji of EMOJI_MAP_DEDUPE) {
    const position = firstPosition.get(emoji.emoji) ?? 0;
    const index = boundaries.findLastIndex(
      (boundary) => boundary >= 0 && boundary <= position,
    );
    sections[Math.max(0, index)].emoji.push(emoji);
  }
  return sections;
})();
